module.exports = __webpack_public_path__ + "img/4_93.5c3d4c11.png";